// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"569":"16a3f96d","595":"16a3f96d","955":"a3e3cc21"}[chunkId] + ".chunk.css";
};